module.exports = __webpack_public_path__ + "img/hr-train-wheels-4.03f5d6ac.png";